export default __webpack_public_path__ + "static/media/b6.312a744d.jpg";